var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHospital(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    stroke: "none",
    fill: "currentColor",
    viewBox: "0 0 62 62",
    height: "1em",
    width: "1em",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.4571 18.1752V3.63086H14.5429V18.1752H0V58.3696H62V18.1752H47.4571ZM3.63281 54.7368V21.808H14.5429V54.7368H3.63281ZM36.455 54.7368H32.8164V50.8938H36.455V54.7368ZM29.1836 54.7368H25.545V50.8938H29.1836V54.7368ZM43.8243 54.7368H40.0878V47.2609H21.9122V54.7368H18.1757V7.26367H43.8243V54.7368ZM58.3672 54.7368H47.4571V21.808H58.3672V54.7368Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1835 21.8139H32.8163V18.1767H36.4535V14.5439H32.8163V10.9067H29.1835V14.5439H25.5463V18.1767H29.1835V21.8139Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.27008 32.7178H10.9058V36.3506H7.27008V32.7178Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.27008 39.9897H10.9058V43.6226H7.27008V39.9897Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0944 32.7178H54.73V36.3506H51.0944V32.7178Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.27008 25.4468H10.9058V29.0796H7.27008V25.4468Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0944 25.4468H54.73V29.0796H51.0944V25.4468Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0944 39.9897H54.73V43.6226H51.0944V39.9897Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1821 25.4468H32.8178V29.0796H29.1821V25.4468Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9108 25.4468H25.5465V29.0796H21.9108V25.4468Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4535 25.4468H40.0891V29.0796H36.4535V25.4468Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1821 32.7178H32.8178V36.3506H29.1821V32.7178Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9108 32.7178H25.5465V36.3506H21.9108V32.7178Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4535 32.7178H40.0891V36.3506H36.4535V32.7178Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1821 39.9897H32.8178V43.6226H29.1821V39.9897Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9108 39.9897H25.5465V43.6226H21.9108V39.9897Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4535 39.9897H40.0891V43.6226H36.4535V39.9897Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHospital);
export default __webpack_public_path__ + "static/media/hospital.a29f6de8acd30a34d1add163b955d661.svg";
export { ForwardRef as ReactComponent };